import axios, { AxiosPromise } from 'axios';
import { IPOFileUpload } from '../../../../@types/model/dispatch/poFileUpload';
import { IPIFileUpload } from '../../../../@types/model/compliance/piFileUpload';

export default class FTPHttpService {
    // CVS export to Teraoka
    public static uploadDispatchCSV(data : { dispatchId : number }) : AxiosPromise<boolean> {
        return axios.post(`${API_URL}/v1/Dispatch/UploadCSV`, data);
    }

    // export PO file to CORE
    public static uploadPOFile(data : IPOFileUpload) : AxiosPromise<boolean> {
        return axios.post(`${API_URL}/v1/Dispatch/UploadPOFile`, data);
    }

    // export PI file to CORE
    public static uploadPIFile(data : IPIFileUpload) : AxiosPromise<boolean> {
        return axios.post(`${API_URL}/v1/Compliance/UploadPIFile`, data);
    }
}
